import { ProjectReleaseGuard } from "@/features/projects";
import DecisivelyLayout, { type DecisilveyLayoutProps } from "./DecisivelyLayout";

// Same as DecisivelyLayout, but for route groups that require an active project
// and release (build, monitor, verify). Mounting the guard here - once per matched
// top-level route group - keeps it from re-checking on every leaf-to-leaf navigation
// within that group, since the group's layout instance persists across those.
const ScopedDecisivelyLayout = (props: DecisilveyLayoutProps) => (
  <ProjectReleaseGuard>
    <DecisivelyLayout {...props} />
  </ProjectReleaseGuard>
);

export default ScopedDecisivelyLayout;
